import PropTypes from 'prop-types';
import React from 'react';
import PlanUtilities from '../../../services/PlanService';
import SubscriptionDiscountService from '../../../services/SubscriptionDiscountService';
import FirstPlanPaymentDescription from './FirstPlanPaymentDescription';
import Configuration from '../../../common/Configuration.json';
import ClickComponentContainer from '../../../redux/containers/ClickComponentContainer';
import ClickSubmitButtonContainer from '../../../redux/containers/ClickSubmitButtonContainer';
import './Order.scss';

const Order = (props) => {
  const connectionFee = props.isContractSelected || props.validatedPromoCode
    ? 0
    : props.connectionPrice;

  const charges = PlanUtilities.getChargeSummary(
    props.isContractSelected,
    connectionFee,
    props.shippingPrice,
    props.modemPrice,
    props.discount,
    props.isByoModemSelected
  );

  const hasSubscriptionDiscount = SubscriptionDiscountService.hasDiscountWithSubscription(
    props.isContractSelected,
    props.subscriptionDiscount);

  return (
    <section>
      {props.discount.enabled && !props.isContractSelected &&
      <div className="container order-discount">
        <div className="discount-maru">
          <div className="section-discount-text">Save</div>
          <div className="section-discount-amount">
            {props.discount.value}
          </div>
        </div>
        <div className="order-discount-text">
          <div>Summer savings for you</div>
          <div>
            To say thanks for joining Skinny broadband on plan with a no term contract
            we’re giving you ${props.discount.value} off the cost of your modem.
          </div>
        </div>
      </div>
      }
      <div className="gray-container-small-margin container">
        <div className="row">
          <div className="col-md-6">
            <div className="charge-summary">
              <h4 className="heading-underline">Order summary: Total to pay now</h4>{/* TODO: Use h3 with h4 styling */}
              <p className="gray-container-left-content autotest-connection-fee">
                Connection Fee
                <span className="float-right">${charges.connectionCost}</span>
              </p>
              {!props.isByoModemSelected && <p className="gray-container-left-content autotest-modem-name">
                <span>{Configuration.modemName}</span>
                <span className="float-right">${charges.modemCost}</span>
              </p>}
              {!props.isByoModemSelected && <p className="gray-container-left-content autotest-shipping-fee">
                <span>Shipping and handling fee</span>
                <span className="float-right">${charges.shippingCost}</span>
              </p>}
              {charges.discountApplied > 0 &&
              <p className="gray-container-left-content autotest-modem-discount line-item-highlight">
                <span>Discount</span>
                <span className="float-right">-${props.discount.value}</span>
              </p>
              }
              {props.offer.enabled &&
              <p className="gray-container-left-content autotest-modem-fee">
                <span>{props.offer.name}</span>
                <span className="float-right">FREE</span>
              </p>
              }
              <p className="gray-container-left-content bold autotest-total-fee">
                <span>Total (incl. GST)</span>
                <span className="float-right font-small">${charges.total}</span>
              </p>
              <p className="gray-container-left-content">
                <FirstPlanPaymentDescription hasSubscriptionDiscount={hasSubscriptionDiscount} />
              </p>
              {/* <p className="gray-container-left-content autotest-creditcardvalidation-reminder">
                <small>
                  From today, a $1 hold is placed on your card simply to validate your card details. This hold is
                  normally removed within 2-3 days and is only there to ensure that there are no delays when we take
                  payment for your Skinny Broadband connection.
                </small>
              </p> */}
            </div>
          </div>
          <div className="col-md-6 order-payment">
            <div>
              {/* TODO: Use h3 with h4 styling */}
              <h4 className="order-zuora-heading heading-underline">Payment details</h4>
              <ClickComponentContainer amount={charges.total} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <ClickSubmitButtonContainer />
          </div>
        </div>
      </div>
    </section>
  );
};

Order.propTypes = {
  isContractSelected: PropTypes.bool,
  validatedPromoCode: PropTypes.bool,
  modemPrice: PropTypes.number,
  connectionPrice: PropTypes.number,
  shippingPrice: PropTypes.number,
  offer: PropTypes.object.isRequired,
  discount: PropTypes.object.isRequired,
  subscriptionDiscount: PropTypes.object.isRequired,
  isByoModemSelected: PropTypes.bool
};

export default Order;



/** WEBPACK FOOTER **
 ** ./src/components/payment/Order/Order.js
 **/